import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { vars, Loader } from '../common'
import Badge from './Badge'
import IconDB from 'assets/SPbotLogo.svg'
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'
import ChatBubble from '../ChatBubble'

const getIcon = (config, minimized) => {
  if(minimized && config.minimizedIcon) {
    return config.minimizedIcon
  }
  return config.icon || IconDB
}

const Launcher = ({
  toggle,
  chatOpened,
  badge,
  config,
  isFetching,
  minimized,
  bubbleText,
  bubbleDelay,
}) => (
  <LaunchButton chatOpened={chatOpened} customStyle={config.style}
    onClick={toggle} disabled={isFetching} >
    <ChatBubble text={bubbleText} delay={bubbleDelay} />
    <Badge badge={badge}/>
    <LaunchIcon src={getIcon(config, minimized)} alt="support chatbot"
      style={{ opacity: isFetching ? 0.5 : 1 }}
    />
    {isFetching && (
      <LoadingOverlay />
    )}
  </LaunchButton>
)

const LoadingOverlay = () => (
  <Overlay>
    <Loader color={vars.white} style={{
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)'
    }} />
  </Overlay>
)

Launcher.propTypes = {
  toggle: PropTypes.func,
  chatOpened: PropTypes.bool,
  badge: PropTypes.number
}

Launcher.defaultProps = {
  config: {}
}
export default Launcher

const LaunchButton = styled.button`
  align-self: flex-end;
  background-color: transparent;
  border: 0;
  height: 100px;
  width: 136px;
  margin-top: 10px;
  padding: 0;
  margin-right: 20px;
  ${props => props.chatOpened ? 'display: none;' : ''}

  ${props => props.customStyle || ''}

  @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px)  {
    bottom: 0;
    margin: 20px;
    position: fixed;
    right: 0;
  }
`

const LaunchIcon = styled.img`
  max-width:100%;
  max-height:100%;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
  text-align: right;
  padding: 25px;
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Launcher/index.js